import {Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges} from '@angular/core';
import {FormArray, FormBuilder, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {
  BoekingType,
  BokkzSalarisClient,
  GrootboekBoeking,
  Werkgever,
  WerkgeverAangifteTijdvak,
  WerkgeverEntity,
  WerkgeverSettings,
} from '../services/api.bokkz.salaris';
import {SelectFormControlItem, SharedUiFormControlsModule} from '@snelstart/ui-form-controls';
import {ClientEntity, Periode} from '../services/api.bokkz.services';
import {BokkzWageDataService} from '../services/bokkz-wage-data-service';
import {BokkzAlgDataService} from '../services/bokkz-alg-data-service';
import {DetailsConfig, SharedUiDetailsModule} from '@snelstart/ui-details';
import {ButtonConfiguration, SharedUiButtonModule} from '@snelstart/ui-button';
import { combineLatest, filter, Observable, Subject, takeUntil } from 'rxjs';
import {SharedUiDialogModule} from '@snelstart/ui-dialog';
import {SharedUiTabModule} from '@snelstart/ui-tab';
import {SharedUiAlertModule} from '@snelstart/ui-alert';
import {CommonModule} from '@angular/common';
import {right} from "@popperjs/core";

@Component({
  selector: 'snelstart-venture-fiscaal-domain-logic-employer',
  styleUrls: ['./employer.component.css'],
  standalone: true,
  templateUrl: './employer.component.html',
  imports: [
    SharedUiButtonModule,
    SharedUiDialogModule,
    SharedUiTabModule,
    SharedUiAlertModule,
    ReactiveFormsModule,
    SharedUiFormControlsModule,
    SharedUiDetailsModule,
    CommonModule
  ]
})
export class EmployerComponent implements OnChanges, OnDestroy {

  @Input() public dialogVisible = false;
  @Input() public sstRelationId: any;
  @Input() public werkgeverEntity = {} as WerkgeverEntity;
  @Output() public dialogVisibleChange = new EventEmitter<boolean>();
  protected readonly right = right;
  private destroy$ = new Subject<void>();
  public clientEntity = {} as ClientEntity;
  public werkgeverFg = {} as FormGroup;
  public settingsFg = {} as FormGroup;
  public grootboeksettingsFg = {} as FormGroup;
  public verzondenPeriodeFg = {} as FormGroup;
  public focusedElementId: string | null = null;
  public selectedYear = {} as string;
  public selectedPeriode = {} as number;
  public selectedTab = 0;
  public hasEinddatum = false;

  public detailsConfig = DetailsConfig.create({
    hideArrowButtons: true,
  });

  public optionsTijdvak: SelectFormControlItem<WerkgeverAangifteTijdvak>[] = [
    {value: WerkgeverAangifteTijdvak.MAAND, label: 'Maand'},
    {value: WerkgeverAangifteTijdvak.VIER_WEKEN, label: 'Vier weken', disabled: true},
    {value: WerkgeverAangifteTijdvak.KWARTAAL, label: 'Kwartaal', disabled: true},
    {value: WerkgeverAangifteTijdvak.JAAR, label: 'Jaar', disabled: true},
  ];
//start tijdelijke code
    private updateOptionsTijdvak(): void {
        const naamWerkgever =
            this.werkgeverFg.get('werkgeverGegevens.naamWerkgever')?.value;

        const vierWekenEnabled =
            naamWerkgever === 'Werkgever THEO (test VIER_WEKEN)';

        this.optionsTijdvak = [
            { value: WerkgeverAangifteTijdvak.MAAND, label: 'Maand' },
            {
                value: WerkgeverAangifteTijdvak.VIER_WEKEN,
                label: 'Vier weken',
                disabled: !vierWekenEnabled,
            },
            { value: WerkgeverAangifteTijdvak.KWARTAAL, label: 'Kwartaal', disabled: true },
            { value: WerkgeverAangifteTijdvak.JAAR, label: 'Jaar', disabled: true },
        ];
    }
//einde tijdelijke code

  public optionsAof: SelectFormControlItem<boolean>[] = [
    {value: true, label: 'Kleine werkgever'},
    {value: false, label: '(Middel)grote werkgever', disabled: true},
  ];

  public optionsCao: SelectFormControlItem<string>[] = [{value: '9999', label: '(9999) Geen CAO van toepassing'}];

  public optionsSector: SelectFormControlItem<string>[] = [
    {value: "", label: "Geen sector van toepassing"},
    {value: "1", label: "1. Agrarisch bedrijf"},
    {value: "2", label: "2. Tabakverwerkende industrie"},
    {value: "3", label: "3. Bouwbedrijf"},
    {value: "4", label: "4. Baggerbedrijf"},
    {value: "5", label: "5. Houten emballage-industrie, houtwaren- en borstelindustrie"},
    {value: "6", label: "6. Timmerindustrie"},
    {value: "7", label: "7. Meubel- en orgelbouwindustrie"},
    {value: "8", label: "8. Groothandel in hout, zagerijen, schaverijen en houtbereidingsindustrie"},
    {value: "9", label: "9. Grafische industrie"},
    {value: "10", label: "10. Metaalindustrie"},
    {value: "11", label: "11. Elektrotechnische industrie"},
    {value: "12", label: "12. Metaal-en technische bedrijfstakken"},
    {value: "13", label: "13. Bakkerijen"},
    {value: "14", label: "14. Suikerverwerkende industrie"},
    {value: "15", label: "15. Slagersbedrijven"},
    {value: "16", label: "16. Slagers overig"},
    {value: "17", label: "17. Detailhandel en ambachten"},
    {value: "18", label: "18. Reiniging"},
    {value: "19", label: "19. Grootwinkelbedrijf"},
    {value: "20", label: "20. Havenbedrijven"},
    {value: "21", label: "21. Havenclassificeerders"},
    {value: "22", label: "22. Binnenscheepvaart"},
    {value: "23", label: "23. Visserij"},
    {value: "24", label: "24. Koopvaardij"},
    {value: "25", label: "25. Vervoer KLM"},
    {value: "26", label: "26. Vervoer NS"},
    {value: "27", label: "27. Vervoer posterijen"},
    {value: "28", label: "28. Taxivervoer"},
    {value: "29", label: "29. Openbaar Vervoer"},
    {value: "30", label: "30. Besloten busvervoer"},
    {value: "31", label: "31. Overig personenvervoer te land en in de lucht"},
    {value: "32", label: "32. Overig goederenvervoer te land en in de lucht"},
    {value: "33", label: "33. Horeca algemeen"},
    {value: "34", label: "34. Horeca catering"},
    {value: "35", label: "35. Gezondheid, geestelijke en maatschappelijke belangen"},
    {value: "38", label: "38. Banken"},
    {value: "39", label: "39. Verzekeringswezen"},
    {value: "40", label: "40. Uitgeverij"},
    {value: "41", label: "41. Groothandel I"},
    {value: "42", label: "42. Groothandel II"},
    {value: "43", label: "43. Zakelijke Dienstverlening I"},
    {value: "44", label: "44. Zakelijke Dienstverlening II"},
    {value: "45", label: "45. Zakelijke Dienstverlening III"},
    {value: "46", label: "46. Zuivelindustrie"},
    {value: "47", label: "47. Textielindustrie"},
    {value: "48", label: "48. Steen-, cement-, glas- en keramische industrie"},
    {value: "49", label: "49. Chemische industrie"},
    {value: "50", label: "50. Voedingsindustrie"},
    {value: "51", label: "51. Algemene industrie"},
    {value: "52", label: "52. Uitzendbedrijven"},
    {value: "53", label: "53. Bewakingsondernemingen"},
    {value: "54", label: "54. Culturele instellingen"},
    {value: "55", label: "55. Overige takken van bedrijf en beroep"},
    {value: "56", label: "56. Schildersbedrijf"},
    {value: "57", label: "57. Stukadoorsbedrijf"},
    {value: "58", label: "58. Dakdekkersbedrijf"},
    {value: "59", label: "59. Mortelbedrijf"},
    {value: "60", label: "60. Steenhouwersbedrijf"},
    {value: "61", label: "61. Overheid, onderwijs en wetenschappen"},
    {value: "62", label: "62. Overheid, rijk, politie en rechterlijke macht"},
    {value: "63", label: "63. Overheid, defensie"},
    {value: "64", label: "64. Overheid, provincies, gemeenten en waterschappen"},
    {value: "65", label: "65. Overheid, openbare nutsbedrijven"},
    {value: "66", label: "66. Overheid, overige instellingen"},
    {value: "67", label: "67. Werk en (re)integratie"},
    {value: "68", label: "68. Railbouw"},
    {value: "69", label: "69. Telecommunicatie"},
  ];

  public optiesMaanden: SelectFormControlItem<number | null>[] = [
    {label: '— Maak een keuze —', value: null},
    {label: 'Januari', value: 1},
    {label: 'Februari', value: 2},
    {label: 'Maart', value: 3},
    {label: 'April', value: 4},
    {label: 'Mei', value: 5},
    {label: 'Juni', value: 6},
    {label: 'Juli', value: 7},
    {label: 'Augustus', value: 8},
    {label: 'September', value: 9},
    {label: 'Oktober', value: 10},
    {label: 'November', value: 11},
    {label: 'December', value: 12},
  ];

  public opties4Weken: SelectFormControlItem<number | null>[] = [
    {label: '— Maak een keuze —', value: null},
    {label: 'Periode 1', value: 1},
    {label: 'Periode 2', value: 2},
    {label: 'Periode 3', value: 3},
    {label: 'Periode 4', value: 4},
    {label: 'Periode 5', value: 5},
    {label: 'Periode 6', value: 6},
    {label: 'Periode 7', value: 7},
    {label: 'Periode 8', value: 8},
    {label: 'Periode 9', value: 9},
    {label: 'Periode 10', value: 10},
    {label: 'Periode 11', value: 11},
    {label: 'Periode 12', value: 12},
    {label: 'Periode 13', value: 13},
  ];

  public optiesKwartaal: SelectFormControlItem<number | null>[] = [
    {label: '— Maak een keuze —', value: null},
    {label: '1e Kwartaal', value: 1},
    {label: '2e Kwartaal', value: 2},
    {label: '3e Kwartaal', value: 3},
    {label: '4e Kwartaal', value: 4},
  ];

  constructor(
    public fb: FormBuilder,
    private bokkzClient: BokkzSalarisClient,
    public algDataService: BokkzAlgDataService,
    public dataService: BokkzWageDataService,
  ) {
    this.werkgeverFg = this.fb.group<WerkgeverEntity>({
      werkgeverGegevens: this.fb.group<Werkgever>({
        naamWerkgever: null as unknown as string,
        loonheffingennummer: null as unknown as string,
        aangifteTijdvak: null as unknown as WerkgeverAangifteTijdvak,
        settings: null as unknown as WerkgeverSettings[],
        postcode: null as unknown as string,
        huisnummer: null as unknown as number,
        toevoeging: null as unknown as string,
        straatnaam: null as unknown as string,
        plaats: null as unknown as string,
        telefoonnummer: null as unknown as string,
        emailadres: null as unknown as string,
        postbus: null as unknown as string,
        kvkNummer: null as unknown as string,
        sbi: null as unknown as string,
        normuren: null as unknown as number,
      }),
      taxId: null as unknown as string,
    });
    this.verzondenPeriodeFg = this.fb.group({
      number: null as unknown as number | null,
    });
    this.settingsFg = this.fb.group({
      settings: this.fb.array<WerkgeverSettings>([]),
    });
    this.detailsConfig = DetailsConfig.create({
      hideArrowButtons: true,
    });
    this.grootboeksettingsFg = this.fb.group({
      grootboeksettings: this.fb.array<GrootboekBoeking>([]),
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.werkgeverEntity !== undefined) {
      this.verzondenPeriodeFg.reset();
      this.algDataService.selectedYear.pipe(takeUntil(this.destroy$)).subscribe((value) => {
        this.selectedYear = String(value);
      });
      this.dataService.selectedPeriode.pipe(takeUntil(this.destroy$)).subscribe((value) => {
        this.selectedPeriode = value;
      });
        combineLatest([
            this.algDataService.client,
            this.dataService.werkgeverEntity,
        ])
            .pipe(
                takeUntil(this.destroy$),
                filter(([client, werkgeverEntity]) => !!client && !!werkgeverEntity)
            )
            .subscribe(([client, werkgeverEntity]) => {
                this.clientEntity = client;
                werkgeverEntity.taxId=client.taxIdWageTax;
                this.werkgeverEntity = werkgeverEntity;
                this.sstRelationId = client.sstRelationId;

                const combinedFormValue = {
                    werkgeverGegevens: {
                        naamWerkgever: client.name,
                        loonheffingennummer: client.taxIdWageTax,
                        postcode: client.postalCode,
                        huisnummer: client.houseNumber,
                        toevoeging: client.numberAddition,
                        straatnaam: client.street,
                        plaats: client.place,
                        telefoonnummer: client.phone,
                        emailadres: client.email,
                    },
                    ...werkgeverEntity,
                } as WerkgeverEntity;

                this.werkgeverFg.patchValue(combinedFormValue, { emitEvent: false });
//behorend bij tijdelijke code
                this.updateOptionsTijdvak();
//einde bij tijdelijke code
            });
      this.updateFormWerkgeverSettings();
      this.updateFormGrootboekSettings();
      if (this.settings.length === 0) {
        this.addRij();
      }
      this.checkEinddatum();
    }
  }

  ngOnDestroy() : void {
    this.destroy$.next();     // stuurt het signaal: "stop!"
    this.destroy$.complete(); // sluit het zendertje af
  }

  public config() {
    return ButtonConfiguration.create({
      onClick: () =>
        new Observable((subscription) => {
          setTimeout(() => {
            subscription.next(true);
            subscription.complete();
            this.saveForm();
          }, 200);
        }),
    });
  }

  onSelectTab(number: number) {
    this.selectedTab = number;
  }

  get settings(): FormArray {
    return this.settingsFg.get('settings') as FormArray;
  }

  get grootboeksettings(): FormArray {
    return this.grootboeksettingsFg.get('grootboeksettings') as FormArray;
  }

  /** Alleen de laatste rij mag verwijderd worden als er > 1 rijen zijn */
  showDeleteButtonSettings(index: number): boolean {
    const length = this.settings.length;
    return length > 1 && index === length - 1;
  }

  addRij(): void {
    const length = this.settings.length;

    // Nieuwe begindatum = dag na einddatum van de laatste regel (indien gezet)
    let newBegin
      :
      Date | null = null;
    if (length > 0) {
      const lastPeriode = (this.settings.at(length - 1).get('periode') as FormGroup)?.getRawValue() as Periode;
      const lastEnd = lastPeriode?.einddatum ? new Date(lastPeriode.einddatum) : null;
      if (lastEnd) {
        const d = new Date(lastEnd);
        d.setDate(d.getDate() + 1);
        newBegin = d;
      }
    }

    const nieuwItem: WerkgeverSettings = {
      periode: {
        begindatum: newBegin as unknown as Date,
        einddatum: null as unknown as Date,
      },
      caoCode: null as unknown as string,
      sectorCode: null as unknown as string,
      kleineWerkgever: null as unknown as boolean,
      pensioenCode: null as unknown as string,
      whkPercentageWga: null as unknown as number,
      whkPercentageWgaVerrekenen: null as unknown as number,
      whkPercentageZw: null as unknown as number,
    };

    this.settings.push(this.createFormGroupSectorCode(nieuwItem));
    this.checkEinddatum();
  }

  /** Verwijder alleen de laatste rij en maak de einddatum van de nieuwe laatste rij leeg (null) */
  verwijderRijSettings(index: number): void {
    const length = this.settings.length;
    if (length <= 1 || index !== length - 1) {
      return; // veiligheid
    }

    this.settings.removeAt(index);

    // Open de nieuwe laatste rij door de einddatum op null te zetten
    const newLastIdx = this.settings.length - 1;
    if (newLastIdx >= 0) {
      const periodeGroup = this.settings.at(newLastIdx).get('periode') as FormGroup;
      if (periodeGroup) {
        periodeGroup.patchValue({einddatum: null});
      }
    }
    this.settings.updateValueAndValidity();
    this.checkEinddatum();
  }

  createFormGroupSectorCode(item ?: WerkgeverSettings): FormGroup {
    return this.fb.group<WerkgeverSettings>({
      periode: this.fb.group<Periode>({
        begindatum: item ? item.periode?.begindatum : (null as unknown as Date),
        einddatum: item ? item.periode?.einddatum : (null as unknown as Date),
      }),
      caoCode: item ? item.caoCode : (null as unknown as string),
      sectorCode: item ? item.sectorCode : (null as unknown as string),
      kleineWerkgever: item ? item.kleineWerkgever : (null as unknown as boolean),
      pensioenCode: item ? item.pensioenCode : (null as unknown as string),
      whkPercentageWga: item ? item.whkPercentageWga : (null as unknown as number),
      whkPercentageWgaVerrekenen: item ? item.whkPercentageWgaVerrekenen : (null as unknown as number),
      whkPercentageZw: item ? item.whkPercentageZw : (null as unknown as number),
    });
  }

  createFormGroupGrootboeksettings(item ?: GrootboekBoeking): FormGroup {
    return this.fb.group<GrootboekBoeking>({
      grootboeknummer: item ? item.grootboeknummer : (null as unknown as string),
      grootboeknaam: item ? item.grootboeknaam : (null as unknown as string),
      boekingType: item ? item.boekingType : (null as unknown as BoekingType),
    });
  }

  trackByFn(index: number): any {
    return index;
  }

  private updateFormWerkgeverSettings(): void {
    const lijst = this.werkgeverEntity.werkgeverGegevens?.settings || [];
    const formArray = this.settingsFg.get('settings') as FormArray;
    const focusedControl = this.focusedElementId ? (document.getElementById(this.focusedElementId) as HTMLElement) : null;

    while (formArray.length > lijst.length) {
      formArray.removeAt(formArray.length - 1);
    }

    for (let i = 0; i < lijst.length; i++) {
      if (i < formArray.length) {
        const control = formArray.at(i) as FormGroup;
        control.patchValue(lijst[i]);
      } else {
        const formGroup = this.createFormGroupSectorCode(lijst[i]);
        formArray.push(formGroup);
      }
    }
    if (focusedControl && document.contains(focusedControl)) {
      focusedControl.focus();
    }
    this.checkEinddatum();
  }

  private updateFormGrootboekSettings() : void {
    const lijst = this.werkgeverEntity.werkgeverGegevens?.grootboekSettings || [];
    const formArray = this.grootboeksettingsFg.get('grootboeksettings') as FormArray;
    const focusedControl = this.focusedElementId ? (document.getElementById(this.focusedElementId) as HTMLElement) : null;

    while (formArray.length > lijst.length) {
      formArray.removeAt(formArray.length - 1);
    }

    for (let i = 0; i < lijst.length; i++) {
      if (i < formArray.length) {
        const control = formArray.at(i) as FormGroup;
        control.patchValue(lijst[i]);
      } else {
        const formGroup = this.createFormGroupGrootboeksettings(lijst[i]);
        formArray.push(formGroup);
      }
    }
    if (focusedControl && document.contains(focusedControl)) {
      focusedControl.focus();
    }
  }

  public checkEinddatum() {
    const raw = this.settings.getRawValue() as WerkgeverSettings[];
    this.hasEinddatum = raw.length > 0 && raw.every((a) => a.periode?.einddatum != null);
  }

  public saveForm() {
    const rawSettings = this.settingsFg.getRawValue().settings || [];
    const settings = (rawSettings as unknown as WerkgeverSettings[]).map((s: WerkgeverSettings) => ({...s,
      periode: {
        ...s.periode,
        einddatum: s.periode?.einddatum ?? null,
      },
    }));

    const wgRaw = this.werkgeverFg.getRawValue();
    const payload: WerkgeverEntity = {
      id: this.werkgeverEntity.id,
      taxId: this.werkgeverEntity.taxId,
      werkgeverGegevens: {
        ...this.werkgeverEntity.werkgeverGegevens,
        naamWerkgever: wgRaw.werkgeverGegevens.naamWerkgever,
        loonheffingennummer: wgRaw.werkgeverGegevens.loonheffingennummer,
        aangifteTijdvak: wgRaw.werkgeverGegevens.aangifteTijdvak,
        postcode: wgRaw.werkgeverGegevens.postcode,
        huisnummer: wgRaw.werkgeverGegevens.huisnummer,
        toevoeging: wgRaw.werkgeverGegevens.toevoeging,
        straatnaam: wgRaw.werkgeverGegevens.straatnaam,
        plaats: wgRaw.werkgeverGegevens.plaats,
        telefoonnummer: wgRaw.werkgeverGegevens.telefoonnummer,
        emailadres: wgRaw.werkgeverGegevens.emailadres,
        postbus: wgRaw.werkgeverGegevens.postbus,
        kvkNummer: wgRaw.werkgeverGegevens.kvkNummer,
        normuren: wgRaw.werkgeverGegevens.normuren,
        sbi: wgRaw.werkgeverGegevens.sbi,
        settings: settings,
        grootboekSettings: this.grootboeksettingsFg.getRawValue().grootboeksettings,
      },
    } as WerkgeverEntity;

    this.dataService.updateWerkgever(payload);
    this.bokkzClient.postOneEmployer(this.sstRelationId, false, String(this.selectedPeriode), this.selectedYear, payload).subscribe({
      next: (werkgever) => {
        this.dataService.updateWerkgever(werkgever);
      },
      error: (err) => {
        console.error('Opslaan werkgever mislukt', err);
      },
    });
  }

  saveWerkgeversInstellingen() {
    this.saveForm();
    this.dialogVisibleChange.emit(false);
  }

}
